(function() {
  'use strict';

  class ProductCustomizationSimple {
    constructor() {
      this.container = document.querySelector('[data-customization-steps]');
      if (!this.container) return;

      this.form = this.container.closest('[data-product-form]');
      if (!this.form) return;

      this.variantInput = this.form.querySelector('[data-variant-id]');
      
      // State
      this.state = {
        tablo: null,
        buket: null,
        polaroid: false,
        frame: 'beyaz'
      };

      this.init();
    }

    init() {
      console.log('[Simple Steps] Initialized');
      this.initModals();
      this.bindEvents();
      this.hideTeeInBlueButtons();
    }

    // Hide TeeInBlue's default buttons
    hideTeeInBlueButtons() {
      const observer = new MutationObserver(() => {
        const container = document.querySelector('[data-teeinblue-container]');
        if (!container) return;

        const buttons = container.querySelectorAll('button[name="add"], .tee-btn-add-to-cart, button[type="submit"]');
        buttons.forEach(btn => {
          if (!btn.dataset.addToCart) {
            btn.style.display = 'none';
          }
        });
      });

      const container = document.querySelector('[data-teeinblue-container]');
      if (container) {
        observer.observe(container, { childList: true, subtree: true });
        
        // Initial hide
        setTimeout(() => {
          const buttons = container.querySelectorAll('button[name="add"], .tee-btn-add-to-cart');
          buttons.forEach(btn => btn.style.display = 'none');
        }, 500);
      }
    }

    // ========================================
    // Modal Management
    // ========================================
    initModals() {
      console.log('[Modals] Initializing...');
      
      // Initialize modals
      this.modals = {
        tablo: new CustomModal('tablo-selection', {
          onConfirm: () => this.confirmTablo()
        }),
        buket: new CustomModal('buket-selection', {
          onConfirm: () => this.confirmBuket()
        }),
        polaroid: new CustomModal('polaroid-upload', {
          onConfirm: () => this.confirmPolaroid()
        })
      };
      
      console.log('[Modals] Initialized:', this.modals);
      this.loadTabloList();
      this.loadBuketProduct();
    }

    // ========================================
    // Load Buket Product
    // ========================================
    async loadBuketProduct() {
      try {
        console.log('[Buket] Loading buket product from Shopify...');
        const response = await fetch('/products/mini-buket.js');
        const buketProduct = await response.json();
        
        console.log('[Buket] Product loaded:', buketProduct.title);
        console.log('[Buket] Variants:', buketProduct.variants.length);
        
        // Render buket variants dynamically
        const buketGrid = document.querySelector('[data-buket-grid]');
        if (buketGrid && buketProduct.variants) {
          buketGrid.innerHTML = ''; // Clear existing
          
          buketProduct.variants.forEach((variant, index) => {
            const item = document.createElement('div');
            item.className = 'buket-item';
            item.dataset.buketVariant = '';
            item.dataset.variantId = variant.id;
            item.dataset.variantTitle = variant.title;
            
            // Optimize image URL - use smaller size for thumbnails
            let imageUrl = variant.featured_image?.src || buketProduct.featured_image?.src || buketProduct.images[0];
            
            // Shopify image resize: width=300 for thumbnails
            if (imageUrl) {
              // Remove existing size params and add width=300
              imageUrl = imageUrl.split('?')[0] + '?width=300';
            }
            
            const imgHtml = imageUrl ? 
              `<img src="${imageUrl}" alt="${variant.title}" loading="lazy" decoding="async">` : 
              '<div class="no-image">💐</div>';
            
            item.innerHTML = `
              <div class="buket-item__image">
                ${imgHtml}
              </div>
              <div class="buket-item__title">${variant.title}</div>
            `;
            
            buketGrid.appendChild(item);
          });
          
          console.log('[Buket] Rendered variants:', buketProduct.variants.length);
          this.bindBuketEvents();
        }
      } catch (error) {
        console.error('[Buket] Error loading product:', error);
        console.log('[Buket] Using fallback buket options');
      }
    }

    bindEvents() {
      // Step buttons - direct modal triggers
      document.querySelectorAll('[data-step-btn]').forEach(btn => {
        btn.addEventListener('click', () => {
          const modalId = btn.dataset.modalTrigger;
          console.log(`[Step Button] Clicked, opening modal: ${modalId}`);
          
          const modal = document.getElementById(modalId);
          if (modal) {
            modal.style.display = 'flex';
            document.body.style.overflow = 'hidden';
            console.log('[Modal] Opened:', modalId);
            
            // Re-load buket product when modal opens
            if (modalId === 'buket-selection') {
              setTimeout(() => {
                console.log('[Buket] Modal opened, reloading product...');
                this.loadBuketProduct();
              }, 100);
            }
          } else {
            console.error('[Modal] Not found:', modalId);
          }
        });
      });

      // Direct confirm button listeners as backup
      const tabloConfirm = document.querySelector('#tablo-selection [data-modal-confirm]');
      console.log('[bindEvents] Tablo confirm button:', !!tabloConfirm);
      if (tabloConfirm) {
        tabloConfirm.addEventListener('click', () => {
          console.log('[Tablo] Direct confirm button clicked');
          this.confirmTablo();
        });
      }

      const buketConfirm = document.querySelector('#buket-selection [data-modal-confirm]');
      console.log('[bindEvents] Buket confirm button:', !!buketConfirm);
      if (buketConfirm) {
        buketConfirm.addEventListener('click', () => {
          console.log('[Buket] Direct confirm button clicked');
          this.confirmBuket();
        });
      }

      const polaroidConfirm = document.querySelector('#polaroid-upload [data-modal-confirm]');
      console.log('[bindEvents] Polaroid confirm button:', !!polaroidConfirm);
      if (polaroidConfirm) {
        polaroidConfirm.addEventListener('click', () => {
          console.log('[Polaroid] Direct confirm button clicked');
          this.confirmPolaroid();
        });
      }

      // Close buttons
      document.querySelectorAll('[data-modal-close]').forEach(closeBtn => {
        closeBtn.addEventListener('click', (e) => {
          const modal = e.target.closest('.custom-modal');
          if (modal) {
            this.closeModal(modal.id);
          }
        });
      });

      // Buket selection events
      this.bindBuketEvents();
    }

    bindBuketEvents() {
      const buketItems = document.querySelectorAll('.buket-item');
      console.log('[Buket] Found buket items:', buketItems.length);
      
      if (buketItems.length === 0) {
        console.warn('[Buket] No buket items found in DOM. Check if buket product exists.');
        
        // Check buket grid
        const buketGrid = document.querySelector('[data-buket-grid]');
        if (buketGrid) {
          console.log('[Buket] Grid found:', buketGrid.innerHTML.substring(0, 200));
        } else {
          console.error('[Buket] Grid not found!');
        }
      }
      
      buketItems.forEach(item => {
        item.addEventListener('click', () => {
          // Remove selected from all
          document.querySelectorAll('.buket-item').forEach(i => i.classList.remove('selected'));
          // Add selected to clicked
          item.classList.add('selected');
          
          console.log('[Buket] Item selected:', item.dataset.variantTitle);
        });
      });
    }

    // ========================================
    // Step 1: Tablo Selection
    // ========================================
    async loadTabloList() {
      try {
        const productHandle = window.location.pathname.split('/').pop();
        console.log('[Tablo List] Loading for product:', productHandle);
        
        const productResponse = await fetch(`/products/${productHandle}.js`);
        const product = await productResponse.json();
        console.log('[Tablo List] Product variants:', product.variants.length);

        const collectionHandle = 'sevgililer-gunu-kisisellestirilebilir-poster-tablolar-kopya';
        const collectionResponse = await fetch(`/collections/${collectionHandle}/products.json?limit=250`);
        const collection = await collectionResponse.json();
        console.log('[Tablo List] Collection products:', collection.products.length);

        const tabloGrid = document.querySelector('[data-tablo-grid]');
        if (!tabloGrid) {
          console.error('[Tablo List] Grid not found!');
          return;
        }

        tabloGrid.innerHTML = '';

        collection.products.forEach((collectionProduct, index) => {
          const variant = product.variants[index];
          if (!variant) {
            console.warn(`[Tablo List] No variant for index ${index}`);
            return;
          }

          console.log(`[Tablo List] Product ${index}:`, {
            title: collectionProduct.title,
            image: collectionProduct.images?.[0],
            variantId: variant.id
          });

          const item = this.createTabloItem(collectionProduct, variant);
          tabloGrid.appendChild(item);
        });

        console.log('[Tablo List] Total items added:', tabloGrid.children.length);
        this.bindTabloEvents();
      } catch (error) {
        console.error('[Tablo List] Error:', error);
      }
    }

    createTabloItem(product, variant) {
      const div = document.createElement('div');
      div.className = 'tablo-item';
      div.dataset.variantId = variant.id;
      div.dataset.productTitle = product.title;

      // Get image URL - Shopify collections API returns src property
      let imageUrl = '';
      if (product.images && product.images.length > 0) {
        imageUrl = product.images[0].src || product.images[0];
      } else if (product.featured_image) {
        imageUrl = product.featured_image;
      }

      const img = imageUrl ? 
        `<img src="${imageUrl}" alt="${product.title}" loading="lazy">` : 
        '<div class="no-image">Resim Yok</div>';

      div.innerHTML = `
        <div class="tablo-item__image">
          ${img}
        </div>
        <div class="tablo-item__title">${product.title}</div>
      `;

      return div;
    }

    bindTabloEvents() {
      document.querySelectorAll('.tablo-item').forEach(item => {
        item.addEventListener('click', () => {
          document.querySelectorAll('.tablo-item').forEach(i => i.classList.remove('selected'));
          item.classList.add('selected');
          
          this.state.tablo = {
            variantId: item.dataset.variantId,
            title: item.dataset.productTitle
          };
          
          console.log('[Tablo] Selected:', this.state.tablo);
        });
      });
    }

    confirmTablo() {
      console.log('[Tablo] confirmTablo called, current state:', this.state);
      
      if (!this.state.tablo) {
        alert('Lütfen bir tablo seçin');
        console.warn('[Tablo] No tablo selected');
        return;
      }

      const frameColor = document.querySelector('[name="frame_color"]:checked');
      this.state.frame = frameColor ? frameColor.value : 'beyaz';
      console.log('[Tablo] Frame color:', this.state.frame);

      // Update variant
      if (this.variantInput) {
        this.variantInput.value = this.state.tablo.variantId;
        this.updateTeeInBlueVariant(this.state.tablo.variantId);
      }

      // Update property
      const tabloProperty = this.form.querySelector('[data-property-tablo-title]');
      if (tabloProperty) {
        tabloProperty.value = this.state.tablo.title;
      }

      const tabloVariantProperty = this.form.querySelector('[data-property-tablo-variant]');
      if (tabloVariantProperty) {
        tabloVariantProperty.value = this.state.tablo.variantId;
      }

      const frameProperty = this.form.querySelector('[data-property-frame-color]');
      if (frameProperty) {
        frameProperty.value = this.state.frame;
      }

      // Update button UI
      const btn = document.querySelector('[data-step-btn="tablo"]');
      if (btn) {
        btn.classList.add('completed');
        const checkmark = btn.querySelector('[data-step-check-tablo]');
        if (checkmark) checkmark.style.display = 'inline';
        const text = btn.querySelector('[data-step-text-tablo]');
        if (text) text.textContent = `Seçilen: ${this.state.tablo.title}`;
      }

      this.closeModal('tablo-selection');
      console.log('[Tablo] Confirmed:', this.state);
    }

    updateTeeInBlueVariant(variantId) {
      if (this.variantInput) {
        this.variantInput.value = variantId;
        
        // Trigger change events for TeeInBlue
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        
        // Dispatch Shopify theme events
        window.dispatchEvent(new Event('resize'));
        setTimeout(() => {
          window.dispatchEvent(new Event('load'));
          document.dispatchEvent(new CustomEvent('shopify:section:load'));
        }, 100);
      }
    }

    // ========================================
    // Step 2: Buket Selection
    // ========================================
    confirmBuket() {
      console.log('[Buket] confirmBuket called');
      
      const selectedBuket = document.querySelector('.buket-item.selected');
      if (!selectedBuket) {
        alert('Lütfen bir buket seçin');
        console.warn('[Buket] No buket selected');
        return;
      }
      
      const buketTitle = selectedBuket.dataset.variantTitle;
      console.log('[Buket] Selected:', buketTitle);

      this.state.buket = {
        title: buketTitle
      };

      // Update property
      const buketProperty = this.form.querySelector('[data-property-buket-title]');
      if (buketProperty) {
        buketProperty.value = this.state.buket.title;
      }

      // Update button UI
      const btn = document.querySelector('[data-step-btn="buket"]');
      if (btn) {
        btn.classList.add('completed');
        const checkmark = btn.querySelector('[data-step-check-buket]');
        if (checkmark) checkmark.style.display = 'inline';
        const text = btn.querySelector('[data-step-text-buket]');
        if (text) text.textContent = `Seçilen: ${this.state.buket.title}`;
      }

      this.closeModal('buket-selection');
      console.log('[Buket] Confirmed:', this.state);
    }

    // ========================================
    // Step 3: Polaroid Upload
    // ========================================
    confirmPolaroid() {
      console.log('[Polaroid] confirmPolaroid called');
      this.state.polaroid = true;

      // Update property
      const polaroidProperty = this.form.querySelector('[data-property-polaroid-count]');
      if (polaroidProperty) {
        // Upload Lift will handle the actual count
        polaroidProperty.value = 'Uploaded';
      }

      // Update button UI
      const btn = document.querySelector('[data-step-btn="polaroid"]');
      if (btn) {
        btn.classList.add('completed');
        const checkmark = btn.querySelector('[data-step-check-polaroid]');
        if (checkmark) checkmark.style.display = 'inline';
      }

      this.closeModal('polaroid-upload');
      console.log('[Polaroid] Confirmed:', this.state);
    }

    // Helper: Close modal by ID
    closeModal(modalId) {
      const modal = document.getElementById(modalId);
      if (modal) {
        modal.style.display = 'none';
        document.body.style.overflow = '';
        console.log(`[Modal] Closed: ${modalId}`);
      }
    }
  }

  // ========================================
  // Custom Modal Class
  // ========================================
  class CustomModal {
    constructor(modalId, options = {}) {
      this.modal = document.getElementById(modalId);
      if (!this.modal) {
        console.warn(`[Modal] Not found: ${modalId}`);
        return;
      }

      this.modalId = modalId;
      this.options = options;
      this.confirmBtn = this.modal.querySelector('[data-modal-confirm]');
      this.cancelBtn = this.modal.querySelector('[data-modal-cancel]');
      this.closeBtn = this.modal.querySelector('[data-modal-close]');

      console.log(`[Modal] Found: ${modalId}`, {
        confirmBtn: !!this.confirmBtn,
        cancelBtn: !!this.cancelBtn,
        closeBtn: !!this.closeBtn
      });
      this.bindEvents();
    }

    bindEvents() {
      // Confirm
      if (this.confirmBtn) {
        this.confirmBtn.addEventListener('click', () => {
          console.log(`[Modal] Confirm clicked: ${this.modalId}`);
          if (this.options.onConfirm) {
            this.options.onConfirm();
          }
        });
      }

      // Cancel/Close
      if (this.cancelBtn) {
        this.cancelBtn.addEventListener('click', () => {
          console.log(`[Modal] Cancel clicked: ${this.modalId}`);
          this.close();
        });
      }
      
      // Close buttons (can be multiple)
      this.modal.querySelectorAll('[data-modal-close]').forEach(closeBtn => {
        closeBtn.addEventListener('click', () => {
          console.log(`[Modal] Close clicked: ${this.modalId}`);
          this.close();
        });
      });

      // Close on overlay click
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal || e.target.classList.contains('custom-modal__overlay')) {
          console.log(`[Modal] Overlay clicked: ${this.modalId}`);
          this.close();
        }
      });
    }

    open() {
      if (!this.modal) return;
      this.modal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
      console.log(`[Modal] Opened: ${this.modalId}`);
    }

    close() {
      if (!this.modal) return;
      this.modal.style.display = 'none';
      document.body.style.overflow = '';
      console.log(`[Modal] Closed: ${this.modalId}`);
    }
  }

  // ========================================
  // Initialize
  // ========================================
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new ProductCustomizationSimple();
    });
  } else {
    new ProductCustomizationSimple();
  }

})();
